(function () {

    'use strict';
    angular.module('iplusjs.button.link', [
        'lodash',
        'iplusjs.utils.button'
    ])
        .directive('iplusjsLinkBtn', linkBtn);

    LinkBtnController.$inject = [
        '$attrs',
        '$state',
        '$timeout',
        'lodash',
        'ButtonUtilsService'
    ];
    function LinkBtnController($attrs, $state, $timeout, _, ButtonUtilsService) {
        var vm = this;

        vm.$onInit = onInit;
        vm.isDisabled = isDisabled;
        vm.click = click;

        function onInit() {
            vm.cssClass = ButtonUtilsService.getButtonCls(vm.clsType ? vm.clsType : 'link', vm.cls);
            vm.btnDesc = getDesc(vm.desc);
            vm.isNavigatable = _.isBoolean(vm.isNavigatable) ? vm.isNavigatable : true;

            $attrs.$observe('ilbDesc', function (desc) {
                vm.btnDesc = getDesc(desc);
            });

            $attrs.$observe('ilbCls', function (cls) {
                vm.cssClass = ButtonUtilsService.getButtonCls(vm.clsType ? vm.clsType : 'link', cls);
            });
        }

        function isDisabled() {
            return vm.disabled || vm.formCtrl && vm.formCtrl.$invalid;
        }

        function getDesc(desc) {
            return desc || 'Zurück';
        }

        function click($event) {
            if (!vm.uiSref) {
                $event && $event.preventDefault();
            } else {
                $timeout(function () {
                    $state.go(vm.uiSref);
                });
            }

            if (_.isFunction(vm.onClick)) {
                $timeout(function () {
                    vm.onClick();
                });
            }
        }
    }

    linkBtn.$inject = [];
    function linkBtn() {
        return {
            restrict: 'EA',
            require: '?^form',
            scope: {
                disabled: '=ngDisabled',
                desc: '@ilbDesc',
                clsType: '@?ilbClsType',
                cls: '@ilbCls',
                onClick: '&?ilbOnClick',
                isNavigatable: '<ilbNavigatable',
                uiSref: '@ilbUiSref',
                tracking: '<?ilbTracking'
            },
            templateUrl: 'common/button/linkBtn.html',
            controller: LinkBtnController,
            controllerAs: 'linkBtnVm',
            bindToController: true
        };
    }
})();
